import React, { useState } from 'react';
import { TrendingUp } from 'lucide-react';

const TrendingTopics = ({ topics = [], onSelect }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Generate a mock percentage change for visual flair
  const getChange = (count) => {
    const change = Math.min(Math.round((count / (topics[0]?.count || 1)) * 15), 15);
    return `+${change}%`;
  };

  const changeColors = ['text-green-600', 'text-green-500', 'text-blue-500', 'text-orange-500'];

  const displayedTopics = isExpanded ? topics : topics.slice(0, 4);
  const hasMore = topics.length > 4;

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-bold text-gray-900">Trending Topics</h3>
        <TrendingUp size={16} className="text-green-500" />
      </div>
      
      {topics.length === 0 ? (
        <p className="text-sm text-gray-400">No trending topics yet.</p>
      ) : (
        <>
          <div className="space-y-3">
            {displayedTopics.map((t, i) => (
              <div 
                key={t.tag} 
                className="flex items-center justify-between cursor-pointer hover:bg-gray-50/50 p-1.5 -mx-1.5 rounded-lg transition-colors"
                onClick={() => onSelect && onSelect(t.tag)}
              >
                <span className="text-sm text-blue-600 font-medium break-all line-clamp-1 mr-2">#{t.tag}</span>
                <div className="flex items-center gap-2">
                  <span className="text-sm text-gray-600 font-medium">{t.count}</span>
                  <span className={`text-xs font-medium ${changeColors[i % changeColors.length]}`}>
                    {getChange(t.count)}
                  </span>
                </div>
              </div>
            ))}
          </div>
          
          {hasMore && (
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="mt-4 w-full py-1.5 text-xs font-semibold text-blue-600 hover:text-blue-700 hover:bg-blue-50 rounded-md transition-colors"
            >
              {isExpanded ? 'View Less' : `View More (${topics.length - 4})`}
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default TrendingTopics;
